// extracted by mini-css-extract-plugin
export default {"burgerscontent":"BurgersContent_burgerscontent__cC16Q"};